module.exports = __webpack_public_path__ + "img/wifi.4cc3060e.png";